import React from 'react';
import PropTypes from 'prop-types';

import { Quote } from '@sm360/widget-commons-vehicle';

import GarageVehicle from 'commons-garage/components/GarageVehicle/GarageVehicle.js';

const GarageViewTabSlide = ({ quote, deleteQuote, isReservationMode }) => {
    const { vehicle } = quote;

    const isQuoteInPending = quote.isQuoteInPending();
    const isQuoteInApproval = quote.isQuoteInApproval();

    const extraWrapperClass =
        isQuoteInPending || isQuoteInApproval ? 'GarageView-tab-wrapper pendingVehicle' : 'GarageView-tab-wrapper';
    const extraSlideBlocClass = isQuoteInPending || isQuoteInApproval ? 'slide-bloc pending-vehicle' : 'slide-bloc';
    const isBookable = !isQuoteInPending && !isQuoteInApproval && isReservationMode;

    return (
        (isBookable || !isReservationMode) && (
            <div className={extraWrapperClass}>
                <div className="GarageView-tab-slide">
                    <div className={extraSlideBlocClass}>
                        <div className="slide-bloc-wrapper">
                            <GarageVehicle
                                vehicleId={vehicle.vehicleId}
                                vehicle={vehicle}
                                quote={quote}
                                deleteQuote={deleteQuote}
                                isReservationMode={isReservationMode}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    );
};

GarageViewTabSlide.propTypes = {
    quote: PropTypes.instanceOf(Quote.QuoteModelV25).isRequired,
    deleteQuote: PropTypes.func.isRequired,
    isReservationMode: PropTypes.bool.isRequired,
};

GarageViewTabSlide.displayName = 'GarageViewTabSlide';

export default GarageViewTabSlide;
